import { render, staticRenderFns } from "./data_board.vue?vue&type=template&id=24e333b8&scoped=true&"
import script from "./data_board.vue?vue&type=script&lang=js&"
export * from "./data_board.vue?vue&type=script&lang=js&"
import style0 from "./data_board.vue?vue&type=style&index=0&id=24e333b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e333b8",
  null
  
)

export default component.exports